import { Box, SxProps, Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { colors } from '../../const/colors'
import { getRunningTag, getVersionLabel } from '../../utils/appVersion'

const AppVersionLabel = ({
  onDark = false,
  sx,
}: {
  onDark?: boolean
  sx?: SxProps<Theme>
}) => {
  const { t } = useTranslation(['generic'])

  return (
    <Box
      component="span"
      data-e2e="app-version"
      title={getRunningTag() || undefined}
      sx={[
        {
          fontSize: '11px',
          fontWeight: 600,
          letterSpacing: '0.04em',
          whiteSpace: 'nowrap',
          color: onDark ? 'rgba(255,255,255,0.45)' : colors.textMuted,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {`${t('generic:version')} ${getVersionLabel()}`}
    </Box>
  )
}

export default AppVersionLabel
